import React from "react"
import PropTypes from "prop-types"
import styled from "react-emotion"
import { Link } from "react-router"
import logoWhite from "assets/images/stacker-logo-white.png"

import StacksPageSidebar from "../components/StacksPageSidebar"
import HeaderItem from "ui/components/HeaderItem"

import {
    Hamburger,
    CloseButton,
    Logo,
    Page,
    Main,
    ClearHeader,
    ContentWrapper,
    Content,
} from "../ui/Layout"
import WithStacks from "data/wrappers/WithStacks"
import { Text, SectionHeader, Card, Container, Section, Button, Heading, Icon } from "ui"
import NewStackButton from "../components/NewStackButton"
import PageTitle from "ui/components/PageTitle"
import CloneStackButton from "../components/CloneStackButton"
class StacksPage extends React.Component {
    state = {}
    render() {
        return (
            <Page>
                <ClearHeader>
                    {/* <Hamburger onClick={() => this.setState({ menuOpen: true })} /> */}
                    <Logo src={logoWhite} alt="Stacker Logo" />
                    <HeaderItem align="right">
                        <Link to="/logout">Logout</Link>
                    </HeaderItem>
                </ClearHeader>
                <Main>
                    {/* <StacksPageSidebar
                        open={this.state.menuOpen}
                        closeButton={
                            <CloseButton onClick={() => this.setState({ menuOpen: false })} />
                        }
                    />  */}
                    <ContentWrapper>
                        <Content>
                            <Section spaced padding="none" margin="none" paddingBottom="large">
                                <PageTitle>Welcome to Stacker</PageTitle>
                                <Text size="fontL" padding="none" margin="none">
                                    Everything in Stacker is built in stacks. Click the plus button
                                    to add a new stack.
                                    <Link to="/templates">
                                        <Button icon="plus" color="clear">
                                            From Template
                                        </Button>
                                    </Link>
                                </Text>
                            </Section>
                            <Heading size="medium">Your Stacks</Heading>
                            <WithStacks>
                                {({ stacks, selectStack }) => (
                                    <Container wrapItems>
                                        {stacks.map(stack => (
                                            <Link to="/tables">
                                                <StackCard
                                                    onClick={() => selectStack(stack._sid)}
                                                    clickable
                                                    flushTopLeft
                                                    margin="large"
                                                    padding="large"
                                                >
                                                    <Heading padding="none" size="small">
                                                        {stack.name}
                                                    </Heading>
                                                    <Text size="fontS">{stack.base_url}</Text>
                                                </StackCard>
                                            </Link>
                                        ))}

                                        <WithStacks>
                                            {({ createStack }) => (
                                                <NewStackButton
                                                    button={({ open }) => (
                                                        <StackCard
                                                            onClick={open}
                                                            clickable
                                                            flushTopLeft
                                                            margin="large"
                                                            padding="large"
                                                            style={{
                                                                background: "",
                                                                textAlign: "center",
                                                                opacity: "0.6",
                                                            }}
                                                        >
                                                            <Text padding="medium" size="fontXXL">
                                                                <Icon
                                                                    style={{
                                                                        fontSize: "60px",
                                                                    }}
                                                                    weight="regular"
                                                                    icon="plus"
                                                                />
                                                            </Text>
                                                            {/* <Text
                                                                size="fontM"
                                                                color="clear"
                                                                padding="small"
                                                                margin="none"
                                                                onClick={open}
                                                            >
                                                                New Stack
                                                            </Text> */}
                                                        </StackCard>
                                                    )}
                                                    onSave={createStack}
                                                />
                                            )}
                                        </WithStacks>
                                    </Container>
                                )}
                            </WithStacks>
                        </Content>
                    </ContentWrapper>
                </Main>
            </Page>
        )
    }
}

StacksPage.propTypes = {
    children: PropTypes.node,
}

export default StacksPage

const StackCard = styled(Card)`
    min-height: 180px;
    max-height: 180px;
    min-width: 180px;
    max-width: 180px;
`



// WEBPACK FOOTER //
// ./src/features/studio/containers/StacksPage.js